import {Component, EventEmitter, OnInit} from '@angular/core';
import {Client} from '../../../../model/client/Client';
import {ActivatedRoute} from '@angular/router';
import {ClientService} from '../../../../service/interne/client/ClientService';
import {DialogueShareService} from '../../../../service/partage/utilitaire/DialogueShareService';
import {Router} from '@angular/router';
import {Organisation} from '../../../../model/organisation/Organisation';
import {Coordonnees} from '../../../../model/information/Coordonnees';
import {FormeJuridique} from '../../../../model/organisation/FormeJuridique';
import {Pays} from '../../../../model/information/Pays';
import {CodeApe} from '../../../../model/organisation/CodeApe';
import {Etat} from '../../../../model/information/Etat';
import {AuthShareService} from '../../../../service/partage/AuthShareService';
import {FormatIntranetShareService} from '../../../../service/partage/prototype/FormatIntranetShareService';
import {OrganisationService} from '../../../../service/interne/organisation/OrganisationService';
import {CodeApeService} from '../../../../service/interne/organisation/CodeApeService';
import {FormeJuridiqueService} from '../../../../service/interne/organisation/FormeJuridiqueService';
import {PaysService} from '../../../../service/interne/contact/PaysService';
import {CoordonneesService} from '../../../../service/interne/coordonnees/CoordonneesService';
import {EtatService} from '../../../../service/interne/etat/EtatService';
import {AuthUser} from '../../../../model/user/authUser';
import {AuthUserService} from '../../../../service/interne/user/AuthUserService';
import {Membre} from '../../../../model/client/Membre';

@Component({
  selector: 'app-escal-client-modifier',
  templateUrl: './escal-client-modifier.component.html',
  styleUrls: ['./escal-client-modifier.component.scss'],
  providers: [ ClientService, OrganisationService, EtatService, CodeApeService, FormeJuridiqueService, CoordonneesService, PaysService, AuthUserService ]
})
export class EscalClientModifierComponent implements OnInit {

  id: number;
  private sub: any;
  client: Client;
  adresse: boolean;
  ancienneAddrGene: string;
  ancienneAddrCoup: string;
  organisation: Organisation;
  coordonnee: Coordonnees;
  dirigeantId: number;
  societeId: number;
  codeId: number;
  categId: number;
  formeId: number;
  etatId: number;
  paysId: number;
  dirigeantsRecherche: Array<any> = [];
  societesRecherche: Array<any> = [];
  categoriesRecherche: Array<any> = [];
  formes: Array<FormeJuridique>;
  etats: Array<Etat>;
  pays: Array<Pays>;
  codes: Array<CodeApe>;
  champRechercheDirigeant: string;
  champRechercheSoc: string;
  champRechercheCode: string;
  champRechercheCateg: string;
  affiche: boolean;
  afficheDirigeant: boolean;
  afficheCode: boolean;
  afficheCateg: boolean;
  rechercheEncours = false;
  rechercheEncoursDirigeant = false;
  rechercheEncoursCateg = false;
  users: Array<AuthUser> = [];
  premierMembreId: number;
  deuxiemeMembreId: number;
  troisiemeMembreId: number;
  membre: Membre;
  refresh = new EventEmitter();
  constructor(private route: ActivatedRoute, private clientService: ClientService, private dialogueShareService: DialogueShareService,
              private router: Router, private authShareService: AuthShareService,
              public formatIntranetShareService: FormatIntranetShareService, private organisationService: OrganisationService,
              private codeApeService: CodeApeService, private formeJuridiqueService: FormeJuridiqueService,
              private paysService: PaysService, private coordonneesService: CoordonneesService, private etatService: EtatService,
              private authUserService: AuthUserService) { }

  ngOnInit() {
    this.adresse = false;
    const that = this;
    this.organisation = new Organisation(0, 0, '', null, null, '', '', '' , '', '',
      null, new Date(), null, null, null, null, null, null, null, [], [], null, [], []);
    this.coordonnee = new Coordonnees(0, '', '', '', '', '', '', '', '', null,
      '', '', this.authShareService.authUser, new Date(), null, 0, null, null, null);
    this.dirigeantId = 0;
    this.societeId = 0;
    this.codeId = 0;
    this.categId = 0;
    this.etatId = 1;
    this.paysId = 0;
    this.formeId = 0;
    this.premierMembreId = 0;
    this.deuxiemeMembreId = 0;
    this.troisiemeMembreId = 0;
    this.affiche = false;
    this.afficheDirigeant = false;
    this.afficheCode = false;
    this.afficheCateg = false;
    this.champRechercheDirigeant = '';
    this.champRechercheSoc = '';
    this.champRechercheCode = '';
    this.champRechercheCateg = '';
    this.dirigeantsRecherche[0] = [];
    this.societesRecherche[0] = [];
    this.categoriesRecherche[0] = [];
    this.codes = [];
    this.sub = this.route.params.subscribe(params => {
      this.clientService.getClientDetail(params.id)
        .then((cli) => {
          that.client = cli as Client;
          this.ancienneAddrGene = that.client.adresseGenerique;
          this.ancienneAddrCoup = that.client.adresseCoupure;
          this.etatId = that.client.etat.id;
          this.organisationService.getInfosClient(that.client.id)
            .then((soc) => {
              const orgs = soc['hydra:member'] as Array<Organisation>;
              this.organisation = orgs[0];
              if (this.organisation.formeJuridique != null) {
                this.formeId = this.organisation.formeJuridique.id;
              }
              if (this.organisation.dirigeant != null) {
                this.dirigeantId = this.organisation.dirigeant.ancienId;
                this.dirigeantsRecherche[0]['id'] = this.dirigeantId;
                this.dirigeantsRecherche[0]['nomPrenom'] = this.organisation.dirigeant.prenom + ' ' + this.organisation.dirigeant.nom;
              }
              if (this.organisation.appartenirA != null) {
                this.societeId = this.organisation.appartenirA.ancienId;
                this.societesRecherche[0]['id'] = this.societeId;
                this.societesRecherche[0]['nom'] = this.organisation.appartenirA.nom;
              }
              if (this.organisation.ape != null) {
                this.codeId = this.organisation.ape.id;
                this.codes.push(this.organisation.ape);
              }
              if (this.organisation.categorieGenerale != null) {
                this.categId = this.organisation.categorieGenerale.ancienId;
                this.categoriesRecherche[0]['id'] = this.categId;
                this.categoriesRecherche[0]['nom'] = this.organisation.categorieGenerale.libelle;
              }
              if (this.organisation.coordonnees != null) {
                this.coordonneesService.getCoordonneesDetails(this.organisation.coordonnees.id).then((coordonnes) => {
                  this.coordonnee = coordonnes as Coordonnees;
                  if (this.coordonnee != null) {
                    if (this.coordonnee.pays != null) {
                      this.paysId = this.organisation.coordonnees.pays.id;
                    }
                  }
                });
              }
            });
          this.clientService.getMembresClient(params.id)
            .then((membres) => {
              const membreTemp = membres['hydra:member'] as Array<Membre>;
              this.membre = membreTemp[0];
              if (this.membre != null) {
                if (this.membre.premierMembre != null) {
                  this.premierMembreId = Number(this.membre.premierMembre.id);
                }
                if (this.membre.deuxiemeMembre != null) {
                  this.deuxiemeMembreId = Number(this.membre.deuxiemeMembre.id);
                }
                if (this.membre.troisiemeMembre != null) {
                  this.troisiemeMembreId = Number(this.membre.troisiemeMembre.id);
                }
              }
            });
        });
    });
    this.authUserService.getUsersList(1).then((usersRetour) => {
      that.users = usersRetour['hydra:member'] as Array<AuthUser>;
    });
    this.etatService.getEtats().then(etats => {
      this.etats = etats['hydra:member'] as Array<Etat>;
    });
    this.paysService.getAllPays().then(pays => {
      this.pays = pays['hydra:member'] as Array<Pays>;
    });
    this.formeJuridiqueService.getFormesJuridiques().then(formesJ => {
      this.formes = formesJ['hydra:member'] as Array<FormeJuridique>;
    });
  }

  modifierClient() {
    if (this.client.nom.length < 1) {
      this.dialogueShareService.addDialogue('Le nom du client est obligatoire');
    } else {
      if (this.adresse === true) {
        this.client.adresseGenerique = this.client.nom.toLowerCase().replace(/\s/g, '') + '@escalconsulting.com';
        this.client.adresseCoupure = 'coupures-' + this.client.nom.toLowerCase().replace(/\s/g, '') + '@escalconsulting.com';
      }
      this.client.nom = this.organisation.nom;
      this.clientService.modifierInfos(this.client, this.etatId)
        .then(() => {
          this.modifierSociete();
          if (this.adresse === true) {
            this.clientService.modifierClientOVH(this.client, this.ancienneAddrGene, this.ancienneAddrCoup)
              .then(() => {
                this.dialogueShareService.addDialogue('Informations mises à jour');
                this.router.navigate(['/escal/client/', this.client.id]);
              });
          } else {
            this.dialogueShareService.addDialogue('Informations mises à jour');
            this.router.navigate(['/escal/client/', this.client.id]);
          }
        });
    }
  }

  modifierSociete() {
    let dirigeantNomPrenom = '';
    // informations obligatoires : Nom et Genre de la société
    if (this.organisation.nom != '') {
        this.organisationService.modifOrganisation(this.organisation, this.formeId, this.codeId, 2).then(org => {
          const organisation = org as Organisation;
          // si société parente renseignée
          if (this.societeId != 0) {
            // on importe la societe à laquelle la nouvelle organisation appartient
            this.organisationService.importerOrganisation(this.societeId).then(() => {
              // on récupère la société importée
              this.organisationService.getDoublonEscalnetSiExiste(this.societeId).then(societe => {
                const socId = societe['hydra:member'][0].id;
                // on l'assigne à la nouvelle organisation
                this.organisationService.addSocieteParent(socId, organisation.id).then(() => {
                });
              });
            });
          }
          // si dirigeant renseigné
          if (this.dirigeantId != 0) {
            // on importe le dirigeant
            this.organisationService.importerDirigeant(this.dirigeantId).then(() => {
              // on récupère le dirigeant renseigné
              this.organisationService.getDirigeantByAncienId(this.dirigeantId).then((dirigeant) => {
                const dirId = dirigeant['hydra:member'][0].id;
                dirigeantNomPrenom = dirigeant['hydra:member'][0].prenom + ' ' + dirigeant['hydra:member'][0].nom;
                // on l'assigne à la nouvelle organisation
                this.organisationService.addDirigeant(dirId, organisation.id).then(() => {
                });
              });
            });
          }
          // si catégorie générale renseignée
          if (this.categId != 0) {
            // on importe la catégorie
            this.organisationService.importerCategorie(this.categId).then(() => {
              // on récupère la catégorie renseignée
              this.organisationService.getCategorieByAncienId(this.categId).then((categorie) => {
                const catId = categorie['hydra:member'][0].id;
                // on l'assigne à la nouvelle organisation
                this.organisationService.addCategorie(catId, organisation.id).then(() => {
                });
              });
            });
          }
          // si au moins un champs de coordonnees renseigné
          if (this.coordonnee.premierTel != '' || this.coordonnee.deuxiemeTel != '' || this.coordonnee.email != '' || this.coordonnee.rue != '' || this.coordonnee.complements != '' || this.coordonnee.boitePostale != '' || this.coordonnee.codePostal != '' || this.coordonnee.ville != '' || this.paysId != 0 || this.coordonnee.premierURL != '' || this.coordonnee.deuxiemeURL != '') {
            // si une coordonnee deja existante
            if (this.coordonnee.id != 0) {
              this.coordonneesService.modifierCoordonnees(this.coordonnee.id, this.coordonnee, organisation.id, this.paysId).then(coord => {
              });
            } else {
              // si pas encore de coordonnee
              this.coordonneesService.addCoordonneeOrganisation(this.coordonnee, organisation.id, this.paysId).then(coord => {
              });
            }
          }
          // modifier la societe dans la base d'intranet (pas d'import, juste màj puisqu'on envoie un ancien id)
          this.organisationService.importerOrganisationIntranet(organisation.id, this.client.ancienId).then((ancienIdSoc) => {
            // insérer l'id d'intranet dans ancienId d'escalnet
            this.organisationService.addAncienIdOrganisation(this.client.ancienId, organisation.id).then((retour) => {
              // CHANGEMENTS PAR RAPPORT A AUTRES SOCIETES
              // modifier client en rajoutant le dirigeant de la société
              if (this.dirigeantId != 0) {
                this.clientService.addDirigeantClient(this.client.id, dirigeantNomPrenom).then((client) => {
                });
              }
              // rappeler la fonction, cette fois pour s'assurer que les promises soient terminés
              this.organisationService.importerOrganisationIntranet(organisation.id, this.client.ancienId).then((fin) => {
              });
            });
            // on modifie l'association Membre
            this.clientService.modifierMembre(this.membre.id, this.premierMembreId, this.deuxiemeMembreId, this.troisiemeMembreId)
              .then(membre => {
              // modifier dans la base intranet
              this.clientService.modifierMembreIntranet(this.client.ancienId, this.premierMembreId, this.deuxiemeMembreId,
                this.troisiemeMembreId).then();
            });
          });
        });
    } else {
      this.dialogueShareService.addDialogue('Le nom est obligatoire');
    }
  }


  rechercheCode() {
    this.codeApeService.getCodesApeRecherche(this.champRechercheCode).then(codes => {
      this.codes = codes['hydra:member'] as Array<CodeApe>;
      this.afficheCode = true;
    });
  }

  rechercheDirigeant() {
    this.afficheDirigeant = true;
    if (this.champRechercheDirigeant.length > 2 && !this.rechercheEncoursDirigeant) {
      this.rechercheEncoursDirigeant = true;
      this.champRechercheDirigeant = this.champRechercheDirigeant.replace(' ', '.');
      this.organisationService.getDirigeantRecherche(this.champRechercheDirigeant).then((retour) => {
        this.dirigeantsRecherche = retour;
        this.dirigeantsRecherche.forEach(dirigeant => {
          if (dirigeant.nomPrenom != '' && dirigeant.nomPrenom != null) {
            dirigeant.nomPrenom = dirigeant.nomPrenom.replace('&amp;', '&');
            dirigeant.nomPrenom = dirigeant.nomPrenom.replace('&#039;', '’');
            dirigeant.nomPrenom = dirigeant.nomPrenom.replace('L&#039;', 'L’');
          }
        });
        this.champRechercheDirigeant = this.champRechercheDirigeant.replace('.', ' ');
      });
      this.rechercheEncoursDirigeant = false;
    }
  }

  rechercheSociete() {
    this.affiche = true;
    if (this.champRechercheSoc.length > 2 && !this.rechercheEncours) {
      this.rechercheEncours = true;
      this.champRechercheSoc = this.champRechercheSoc.replace(' ', '.');
      this.organisationService.getSocieteRecherche(this.champRechercheSoc).then((retour) => {
        this.societesRecherche = retour;
        this.societesRecherche.forEach(societe => {
          if (societe.nom != '' && societe.nom != null) {
            societe.nom = societe.nom.replace('&amp;', '&');
            societe.nom = societe.nom.replace('&#039;', '’');
            societe.nom = societe.nom.replace('L&#039;', 'L’');
          }
        });
        this.champRechercheSoc = this.champRechercheSoc.replace('.', ' ');
      });
      this.rechercheEncours = false;
    }
  }

  rechercheCategories() {
    this.afficheCateg = true;
    if (this.champRechercheCateg.length > 2 && !this.rechercheEncoursCateg) {
      this.rechercheEncoursCateg = true;
      this.champRechercheCateg = this.champRechercheCateg.replace(' ', '.');
      this.organisationService.getCategoriesRecherche(this.champRechercheCateg).then((retour) => {
        this.categoriesRecherche = retour;
        this.categoriesRecherche.forEach(categorie => {
          if (categorie.nom != '' && categorie.nom != null) {
            categorie.nom = categorie.nom.replace('&amp;', '&');
            categorie.nom = categorie.nom.replace('&#039;', '’');
            categorie.nom = categorie.nom.replace('L&#039;', 'L’');
          }
        });
        this.champRechercheCateg = this.champRechercheCateg.replace('.', ' ');
      });
      this.rechercheEncoursCateg = false;
    }
  }

isActive(event) {
    if (event == true) {
      this.adresse = true;
    } else {
      this.adresse = false;
    }
}

}
